import type React from 'react';
import styles from './Specifications.module.css';

interface DeleteSchemaModalProps {
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteSchemaModal: React.FC<DeleteSchemaModalProps> = ({ loading, onClose, onConfirm }) => {
  return (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Delete Schema</h3>
        </div>
        <div className={styles.modalBody}>
          Are you sure you want to delete this schema? This action cannot be undone.
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.button} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.button} data-variant="primary" onClick={onConfirm} disabled={loading}>
            Delete Schema
          </button>
        </div>
      </div>
    </div>
  );
};
